var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "rotate(-180 12.5 12.5)",
    fill: "#1BB4A4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3856 15.6254C11.3142 15.6252 11.2436 15.6102 11.1782 15.5816C11.1128 15.5529 11.054 15.5111 11.0054 15.4587L8.47419 12.766C8.37956 12.6652 8.32888 12.5309 8.33327 12.3927C8.33767 12.2545 8.39679 12.1236 8.49762 12.029C8.59846 11.9344 8.73276 11.8837 8.87097 11.8881C9.00918 11.8925 9.13998 11.9516 9.2346 12.0525L11.3804 14.3389L15.7606 9.54726C15.8051 9.4919 15.8604 9.44622 15.9231 9.41302C15.9859 9.37981 16.0548 9.35979 16.1255 9.35417C16.1963 9.34855 16.2675 9.35747 16.3347 9.38036C16.4019 9.40325 16.4637 9.43963 16.5163 9.48728C16.5689 9.53493 16.6113 9.59283 16.6407 9.65743C16.6701 9.72204 16.686 9.79198 16.6875 9.86295C16.6889 9.93393 16.6758 10.0044 16.649 10.0702C16.6221 10.1359 16.5822 10.1955 16.5315 10.2452L11.7711 15.4535C11.723 15.5068 11.6643 15.5496 11.5989 15.5792C11.5335 15.6088 11.4627 15.6245 11.3909 15.6254H11.3856Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -100,
    y: -100,
    width: 225,
    height: 225,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.008ac6822fbc37659445feae8902c043.svg";
export { ForwardRef as ReactComponent };